var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VuePerfectScrollbar',{key:_vm.$vs.rtl,tag:"component",staticClass:"filters_scroll_area",attrs:{"settings":_vm.settings}},[_c('Filters',{attrs:{"filters":_vm.selects},on:{"updateData":_vm.updateData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }